import Example from '../../components/Example/Example';
import Footer from '../../components/Footer/Footer';
import Pricing from '../../components/Pricing/Pricing';
import '../../styles/main.scss';
import { useEffect, useState } from "react";
import {useNavigate} from "react-router-dom";


const Homepages = () => {
    const navigate = useNavigate();
    const [stats, setStats] = useState({
        cems: 0,
        cemsUnit: '0%',
        rata: 0,
        rataUnit: 1,
        cga: 0,
        cgaUnit: 1,
        daily: 0,
        dailyUnit: 0,
        maintenanceCost: 0,
        maintenanceUnit: '0%',
        das: 0,
        totalAcost: 0
    })
    const handleChange = (e)=>{
        const {name, value} = e.target;
        let inputVal = value.replace(/,/g, '');
        setStats((prevState) => ({
            ...prevState,
            [name]: inputVal
        }));
    }
    const onClickBtn = (e)=> {
        navigate('/confirm', {state:stats, replace: true})
    }
    const parsePercentage = (str) => {
        return str ? parseFloat(str.replace('%', '')) / 100 : 0;
    }
    
    useEffect(() => {
        const cemsUnitNum = parsePercentage(stats.cemsUnit);
        const maintenanceSpend = parsePercentage(stats.maintenanceUnit);

        // compute maintenance Cost
        const mnCost = parseFloat(stats.cems) * maintenanceSpend;

        const totalCost = parseFloat(stats.cems * cemsUnitNum) + parseInt(stats.rata * stats.rataUnit) + 
                            parseInt(stats.cga * stats.cgaUnit) + parseInt(stats.daily * stats.dailyUnit * 365) + 
                            parseFloat(stats.cems) * maintenanceSpend + parseInt(stats.das);
        setStats((prevState) => ({
            ...prevState,
            maintenanceCost: mnCost,
            totalAcost: totalCost
        }))
    }, [stats.cems, stats.cemsUnit, stats.rata, stats.rataUnit, stats.cga, stats.cgaUnit, stats.daily, 
        stats.dailyUnit, stats.maintenanceUnit, stats.das]);

    
    return (
        <div className='main'>
            <Pricing stats={stats} handleChange={handleChange} onClickBtn={onClickBtn}/>
            <Example />
            <Footer />
        </div>
    )
}
export default Homepages;